const BillingAddresses = ({ user }) => {
    
    const { name, billing_address } = user?.company || {};
    const { address_line_1, address_line_2, address_line_3 } = billing_address || {};

    return (
        <div  className="cart-table border border-gray-100 rounded-8 px-20 py-28 mt-20">  
            <h6 className="text-xl mb-32">Billing address</h6>                  
            <div>            
                <div className='row mb-10'>
                    <div className="col-md-3">Company name</div>
                    <div className="ml-auto col-md-9">{name}</div>
                </div>            
            
                <div className='row mb-10'>
                    <div className="col-md-3">Address</div>
                    <div className="ml-auto col-md-9">{address_line_1 || address_line_2 || address_line_3}</div>
                </div>            
            
                <div className='row mb-10'>
                    <div className="col-md-3">Recipient</div>
                    <div className="ml-auto col-md-9">-</div>
                </div> 
            </div>   
        </div>
    );
};

export default BillingAddresses;
